import React, { PropTypes } from 'react';
import StreamEditForm from '../StreamEditForm';
import LoadingSpinner from '../../../LoadingSpinner';

class StreamEdit extends React.Component {
  static propTypes = {
    model: PropTypes.object,
    fetch: PropTypes.func.isRequired,
    loading: PropTypes.bool.isRequired
  };

  componentDidMount() {
    this.props.fetch(this.props.params.id);
  }

  render() {
    let {loading, rest } = this.props;

    return (
      <LoadingSpinner show={loading}>
        <div>
          <StreamEditForm label="Edit Stream" {...rest}/>
          <br/>
        </div>
      </LoadingSpinner>
    );
  }

}

export default StreamEdit;



// WEBPACK FOOTER //
// ./src/components/Stream/LiveStream/StreamEdit/StreamEdit.jsx